import { InputBase } from "@mui/material";
import { styled } from "@mui/material/styles";

// Search
export const Search = styled("div")(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: 'var(--color-BasicBg)',
  '&:hover': {
    background: 'none',
  },
  marginRight: theme.spacing(0),
  marginLeft: 0,
  // width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(0),
    // width: '100%',
  },
}));

export const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 1),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "var(--color-PrimaryText)",
  zIndex: 1,
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  position: 'relative',
  '& .MuiInputBase-input': {
    padding: theme.spacing('10px 10px 10px 40px'),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    // width: '100%',
    border: '1px solid transparent', // fallback
    borderRadius: '8px',
    backgroundOrigin: 'border-box',
    backgroundClip: 'padding-box, border-box',
    backgroundImage: `linear-gradient(#fff, #fff), linear-gradient(270deg, 
        var(--color-orange-49, #D1882A) 8%, 
        var(--color-orange-52, #DA9B31) 19%, 
        var(--color-yellow-65, #FCDB51) 32.5%, 
        var(--color-yellow-8595, rgba(254, 250, 182, 0.95)) 44%, 
        var(--color-yellow-65, #FCDB51) 61.53%, 
        var(--color-orange-52, #DA9B31) 79.5%
      )
    `,
    [theme.breakpoints.up('md')]: {
      width: '200px',
    },
  },
}));
